<template>
  <material-category-page />
</template>

<script>
import MaterialCategoryPage from '../_material_category/index.vue';

export default {
  name: 'OlympiadPage',
  components: { MaterialCategoryPage },
};
</script>
